import { getBlockComponentForContent } from '../../utils/cms-utils';
import styles from './start-spleis-box-wrapper.module.less';
const StartSpleisBoxWrapper = ({ list, backgroundColor }) => {
    const blockComponents = list.map((e) => getBlockComponentForContent({ data: e }));
    return (
        <div className={styles.wrapper} style={{ backgroundColor }}>
            <div className={styles.container}> {blockComponents}</div>
        </div>
    );
};

export default StartSpleisBoxWrapper;
